/**
 * https://elartica.com/2017/08/03/woocommerce-ajax-add-cart-single-product-page/
 */
export default function cartDrawer () {
  const $ = jQuery;
  const $cartDrawerCloseBtn = $( '.cart-drawer__close-btn' );
  const $cartDrawer         = $( '.cart-drawer' );
  const $singleAddToCartBtn = $( '.single_add_to_cart_button' );
  const $siteContainer      = $( '.site-container' );

  $( document ).on( 'click', '.cart-drawer__close-btn', function( e ) {
    closeCartDrawer();
  });


  function openCartDrawer() {
    $cartDrawer.addClass( 'active' );
    $cartDrawer.attr( 'aria-hidden', 'false' );
    $( '.site-container, body' ).addClass( 'cart-drawer-active' );
  }

  function closeCartDrawer() {
    $cartDrawer.removeClass( 'active' );
    $cartDrawer.attr( 'aria-hidden', 'true' );
    $( 'body, .site-container' ).removeClass( 'cart-drawer-active' );
  }

  // Ajax add to cart on the product page
  var $warp_fragment_refresh = {
    url: wc_cart_fragments_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_refreshed_fragments' ),
    type: 'POST',
    success: function( data ) {
      if ( data && data.fragments ) {
        $.each( data.fragments, function( key, value ) {
          $( key ).replaceWith( value );
        });

        $( document.body ).trigger( 'wc_fragments_refreshed' );
      }
    }
  };

  // Add to Cart Single button open drawer, AJAX Update cart.
  $( '.summary form.cart' ).on( 'submit', function ( e ) {
    e.preventDefault();

    var product_id = $(this).find('input.variation_id').val();

    var qty = $(this).find('.qty').val();


    if ( ! $( this ).hasClass('variations_form') ) {
      var product_id = $(".single_add_to_cart_button").val();
    }

    $.ajax( wc_add_to_cart_params.ajax_url, {
      data: {
        action: 'add_to_cart',
        products: [ product_id ],
        quantity: qty
      },
      method: 'POST',
      success: function( data ) {
        if ( data && data.fragments ) {
          $.each( data.fragments, function( key, value ) {
            $( key ).replaceWith( value );
          });
          $( document.body ).trigger( 'wc_fragments_refreshed' );
          $cartDrawer.addClass( 'active' );
          $cartDrawer.attr( 'aria-hidden', 'false' );
          $( '.site-container, body' ).addClass( 'cart-drawer-active' );
        }
      }
    });
  });

  // Close cart drawer when clicking off.
  $siteContainer.on( 'click', function( e ) {
    if ( $( '.site-container' ).hasClass( 'cart-drawer-active' ) && $(e.target).closest('[data-action="open-cart-drawer"]').length === 0 ) {
      closeCartDrawer();
    }
  });

  $('[data-action="open-cart-drawer"]').click(function(event) {
    event.preventDefault();
    openCartDrawer();
  });

  //Custom add to cart that allows multiple items
  $( document ).on( 'click', '[data-action="add-to-cart"]', function( e ) {
    e.preventDefault();
    var products = JSON.parse( $(this).attr('data-products') );

    $.ajax( wc_add_to_cart_params.ajax_url, {
      data: {
        action: 'add_to_cart',
        products: products
      },
      method: 'POST',
      success: function( data ) {
        if ( data && data.fragments ) {
          $.each( data.fragments, function( key, value ) {
            $( key ).replaceWith( value );
          });
          $( document.body ).trigger( 'wc_fragments_refreshed' );

          openCartDrawer();
          $( 'body' ).trigger( 'update_checkout' );
          $( 'body' ).trigger('checkout_shipping_update');
        }
      }
    });

    
  });


  // AJAX Update Product Quantity.
  $( document ).on( 'click', '.quantity-btn.plus-btn, .quantity-btn.minus-btn', function ( e ) {
    e.preventDefault();
    let currentVal = parseInt( $( this ).siblings( '.item-quantity' ).val(), 10 );

    if ( $( this ).hasClass( 'minus-btn' ) ) {
      if ( currentVal <= 1 ) {
        return;
      }

      var newQtyVal = currentVal - 1;
      $( this ).siblings( '.item-quantity' ).val( newQtyVal );
    }

    if ( $( this ).hasClass( 'plus-btn' ) ) {
      var newQtyVal = currentVal + 1;
      $( this ).siblings( '.item-quantity' ).val( newQtyVal );
    }

    var product_id    = $( this ).attr( 'data-product_id' ),
    cart_item_key     = $( this ).attr( 'data-cart_item_key' ),
    product_container = $( this ).parents( '.cart-drawer-item' );

    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: wc_add_to_cart_params.ajax_url,
      data: {
        action: "product_update_qty",
        product_id: product_id,
        cart_item_key: cart_item_key,
        new_qty: newQtyVal
      },
      success: function(response) {
        if ( ! response || response.error )
          return;

        var fragments = response.fragments;

        // Replace fragments
        if ( fragments ) {
          $.each( fragments, function( key, value ) {
            $( key ).replaceWith( value );
          });
        }
        $( document.body ).trigger( 'wc_fragments_refreshed' );
      }
    });
  })

  // AJAX Delete product in the cart
  $( document ).on( 'click', '.cart-drawer-item a.remove', function ( e ) {
    e.preventDefault();

    var product_id    = $( this ).attr( 'data-product_id' ),
    cart_item_key     = $( this ).attr( 'data-cart_item_key' ),
    product_container = $( this ).parents( '.cart-drawer-item' );


    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: wc_add_to_cart_params.ajax_url,
      data: {
        action: "product_remove",
        product_id: product_id,
        cart_item_key: cart_item_key
      },
      success: function(response) {
        if ( ! response || response.error )
          return;

        var fragments = response.fragments;

        // Replace fragments
        if ( fragments ) {
          $.each( fragments, function( key, value ) {
            $( key ).replaceWith( value );
          });
        }
      }
    });
});

};
